module.exports = __webpack_public_path__ + "ef212f1ca4129168afc851f2a79506a4.svg";